/**
 * cypAdhdFirestorePaths.js
 *
 * Thin wrappers around the module-parameterised path builders in
 * modularFirestorePaths.js, pre-bound to the 'cypAdhd' module.
 *
 * CYP ADHD path layout:
 *   patients/{patientId}/cyp_adhd/assessment_001
 *   patients/{patientId}/cyp_adhd/assessment_001/assessmentStages/{stageKey}
 *   patients/{patientId}/cyp_adhd/assessment_001/reportContent/{stageKey}
 *
 *   informants/{informantUid}/patients/{patientId}/cyp_adhd/assessment_001
 *   informants/{informantUid}/patients/{patientId}/cyp_adhd/assessment_001/formInstances/{formKey}
 *
 * Note: CYP ADHD patients do not have patient-side formInstances — all forms
 * are answered by informants (guardians and school representatives).
 */

import {
  getAssessmentDocPathSegments,
  getAssessmentStagePathSegments,
  getReportContentPathSegments,
  getPatientHeaderPathSegments as _getPatientHeaderPathSegments,
  getInformantAssessmentBaseSegments,
  getInformantFormInstancePathSegments,
  joinFirestorePath as _joinFirestorePath,
} from './modularFirestorePaths';

const CYP_ADHD_COLLECTION = 'cyp_adhd';
export const CYP_ADHD_ASSESSMENT_DOC_ID = 'assessment_001';

/** @returns {string[]} */
export function getPatientHeaderPathSegments(patientId) {
  return _getPatientHeaderPathSegments(patientId);
}

/** @returns {string[]} */
export function getCypAdhdAssessmentDocPathSegments(patientId) {
  return getAssessmentDocPathSegments(patientId, CYP_ADHD_COLLECTION, CYP_ADHD_ASSESSMENT_DOC_ID);
}

/** @returns {string[]} */
export function getCypAdhdAssessmentStagePathSegments(patientId, stageKey) {
  return getAssessmentStagePathSegments(patientId, CYP_ADHD_COLLECTION, CYP_ADHD_ASSESSMENT_DOC_ID, stageKey);
}

/** @returns {string[]} */
export function getCypAdhdReportContentPathSegments(patientId, stageKey) {
  return getReportContentPathSegments(patientId, CYP_ADHD_COLLECTION, CYP_ADHD_ASSESSMENT_DOC_ID, stageKey);
}

/** @returns {string[]} */
export function getCypAdhdInformantAssessmentBaseSegments(informantUid, patientId) {
  return getInformantAssessmentBaseSegments(informantUid, patientId, CYP_ADHD_COLLECTION, CYP_ADHD_ASSESSMENT_DOC_ID);
}

/** @returns {string[]} */
export function getCypAdhdInformantFormInstancePathSegments(informantUid, patientId, formKey) {
  return getInformantFormInstancePathSegments(informantUid, patientId, CYP_ADHD_COLLECTION, CYP_ADHD_ASSESSMENT_DOC_ID, formKey);
}

/** @returns {string} */
export function joinFirestorePath(segments) {
  return _joinFirestorePath(segments);
}
